export default __webpack_public_path__ + "static/media/sunMoon.38b766a7.svg";